export const printMultipleQRCodes = async (qrCodes, sponsors, printTitle) => {
  try {
    // Generate all QR code blob URLs
    const qrDataPromises = qrCodes.map(async (qrCode, index) => {
      const blob = await qrCode.getRawData("png");
      const url = URL.createObjectURL(blob);
      return {
        url,
        sponsor: sponsors[index],
      };
    });

    const qrData = await Promise.all(qrDataPromises);

    const printWindow = window.open("", "_blank");

    // Generate HTML for each QR code on separate pages
    const qrPagesHTML = qrData
      .map(
        (data, index) => `
      <div class="qr-page ${index < qrData.length - 1 ? "page-break" : ""}">
        <div class="qr-container">
          <h2>${data.sponsor.name}</h2>
          <img src="${data.url}" class="qr-image" />
          <p class="qr-code-text">${data.sponsor.code || ""}</p>
        </div>
      </div>
    `
      )
      .join("");

    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${printTitle || "Print QR Codes"}</title>
        <style>
          @media print {
            @page {
              size: A4 portrait;
              margin: 20mm;
            }
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .page-break {
              page-break-after: always;
            }
          }
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: Arial, sans-serif;
          }
          
          .qr-page {
            width: 100%;
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
          }
          
          .qr-container {
            text-align: center;
            max-width: 600px;
          }
          
          h2 {
            font-size: 32px;
            margin-bottom: 30px;
            color: #333;
          }
          
          .qr-image {
            width: 500px;
            height: 500px;
            display: block;
            margin: 0 auto;
            max-width: 100%;
            height: auto;
          }
          
          .qr-code-text {
            font-size: 18px;
            margin-top: 20px;
            color: #666;
            font-family: monospace;
          }
        </style>
      </head>
      <body>
        ${qrPagesHTML}
        <script>
          const images = document.querySelectorAll('.qr-image');
          let loadedCount = 0;
          
          images.forEach(img => {
            img.onload = () => {
              loadedCount++;
              if (loadedCount === images.length) {
                setTimeout(() => {
                  window.print();
                }, 250);
              }
            };
          });
          
          window.onafterprint = () => {
            ${qrData.map((data) => `URL.revokeObjectURL('${data.url}');`).join("\n            ")}
            window.close();
          };
          
          setTimeout(() => {
            if (loadedCount < images.length) {
              console.error('Some images failed to load');
              window.close();
            }
          }, 10000);
        </script>
      </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
  } catch (error) {
    console.error("Error printing QR codes:", error);
  }
};
